export function getQueryStringParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
export function getQueryStringParameterByNameRaw(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return results[2];
}

export function selectByLabel (checkLabel, dataList) {
  // goes through an options array used for select lists and returns the value corresponding to the passed in label
  // Assumes format:    {val: myVal, label: 'my label'}

  for (var i=0; i < dataList.length; i++) {
    if (dataList[i].label == checkLabel) {
      return dataList[i].val;
    }
  }

  return null;
}

export function selectByVal (checkVal, dataList) {
  // goes through an options array used for select lists and returns the label corresponding to the passed in value
  // Assumes format:    {val: myVal, label: 'my label'}

  for (var i=0; i < dataList.length; i++) {
    if (dataList[i].val == checkVal) {
      return dataList[i].label;
    }
  }

  return null;
}

export function generateUUID() {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

export function getRandomInt(min, max) {
  // Returns a random integer between min (inclusive) and max (inclusive)
  // Using Math.round() will give you a non-uniform distribution!

  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function arrRemoveBlanks(a) {
  // removes any empty items from an array
  if (!a.length) return [];

  // go backwards so array length is not a factor
  for (var i = a.length-1; i >= 0; i--) {
    if (!a[i]) {
      a.splice(i,1);
    }
  }
  return a;
}


export function testConnection() {
  // make sync-ajax request
  var xhr = new XMLHttpRequest();
  // phone home
  xhr.open('HEAD', '/', false); // async=false
  try {
    xhr.send();
    onLine = true;
  } catch (e) {
    // throws NETWORK_ERR when disconnected
    onLine = false;
  }

  return onLine; 
}

export function idFullStory(storeId) {
  try {
    if(typeof FS != "undefined"){
      if (FS.identify) {
        console.log('set Full Story Id');

        if (storeId) {
          FS.identify( storeId, { email: ''+storeId });
        }
      }
    }
  } catch (e) {
    // Full Story is not available
  }
}

export function checkFilterCriteria(criteria, data) {
  // returns true if data matches criteria or wildcard specified
  // or doesn't match if ! is 1st char of criteria

  if (!criteria || !data) {
    return false;
  }

  // WILDCARD
  if (criteria == '*') {
    return true;
  }

  if (criteria == data) {
    return true;
  }

  // NOT
  if (criteria && criteria.substring(0,1) == '!') {
    // strip away 1st char
    let check = criteria.substring(1);
    if (check != data) {
      return true;
    }

  }

  return false;

}


// WEBPACK FOOTER //
// ./src/common/utils.js